/***
 * @Author: hippo
 * @Date: 2024-01-15 10:54:37
 * @LastEditors: hippo
 * @LastEditTime: 2024-12-27 15:52:25
 * @Description: 
 * @
 */
import { put, call, select, delay, race } from 'redux-saga/effects'
import { createModal } from 'redux-saga-modal'
import {
  FETCH_LIST,
  FETCH_RETAIL_LIST,
  SHOW_INVT_DIALOG,
  SET_ACTIVE_STATE,
  SHOW_LINK_LIST_DIALOG,
  SHOW_MANAGER_LIST_DIALOG,
  SHOW_RETAIL_LINK_LIST_DIALOG,
  SHOW_RETAIL_MANAGER_LIST_DIALOG,
  SHOW_BIND_DIALOG,
  SHOW_RETAIL_BIND_DIALOG,
} from './actionTypes'
// import { getSessionList } from './selectors'
import * as services from './services'
import * as actions from './actions'
import { message } from 'antd'

export default {
  *[FETCH_LIST]({ payload }) {
    const { params } = payload
    yield actions.toggleLoading()
    const { data, total } = yield call(services.fetchList, params)
    yield put(actions.listFetched({ data, total }))
    yield actions.toggleLoading()
  },
  *[FETCH_RETAIL_LIST]({ payload }) {
    const { params } = payload
    yield actions.toggleLoading()
    const { data, total } = yield call(services.fetchRetailList, params)
    yield put(actions.listFetched({ data, total }))
    yield actions.toggleLoading()
  },

  *[SHOW_INVT_DIALOG]({ payload }) {
    const { params } = payload
    const modal = createModal('INVITATIONS_DIALOG')

    yield modal.show(params)

    const { submit } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })

    if (submit) {
      yield modal.hide()
    } else {
      yield modal.destroy()
    }
  },

  *[SHOW_LINK_LIST_DIALOG]({ payload }) {
    const { params } = payload
    const modal = createModal('REFERRALS_BINDING_LIST_DIALOG')

    yield modal.show(params)

    const { submit } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })

    if (submit) {
      yield modal.hide()
    } else {
      yield modal.destroy()
    }
  },
  *[SHOW_MANAGER_LIST_DIALOG]({ payload }) {
    const { params } = payload
    const modal = createModal('REFERRALS_MANAGER_LIST_DIALOG')

    yield modal.show(params)

    const { submit } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })

    if (submit) {
      yield modal.hide()
    } else {
      yield modal.destroy()
    }
  },
  *[SHOW_RETAIL_LINK_LIST_DIALOG]({ payload }) {
    const { params } = payload
    const modal = createModal('RETAIL_BINDING_LIST_DIALOG')

    yield modal.show(params)

    const { submit } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })

    if (submit) {
      yield modal.hide()
    } else {
      yield modal.destroy()
    }
  },
  *[SHOW_RETAIL_MANAGER_LIST_DIALOG]({ payload }) {
    const { params } = payload
    const modal = createModal('RETAIL_MANAGER_LIST_DIALOG')

    yield modal.show(params)

    const { submit } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })

    if (submit) {
      yield modal.hide()
    } else {
      yield modal.destroy()
    }
  },
  *[SHOW_BIND_DIALOG]({ payload }) {
    const { params } = payload
    const modal = createModal('REFERRALS_BINDING_DIALOG')

    yield modal.show(params)

    const { submit } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })

    if (submit) {
      yield modal.hide()
    } else {
      yield modal.destroy()
    }
  },

  *[SHOW_RETAIL_BIND_DIALOG]({ payload }) {
    const { params } = payload
    const modal = createModal('RETAIL_REFERRALS_BINDING_DIALOG')

    yield modal.show(params)

    const { submit } = yield race({
      submit: modal.takeSubmit(),
      hide: modal.takeHide(),
    })

    if (submit) {
      yield modal.hide()
    } else {
      yield modal.destroy()
    }
  },

  *[SET_ACTIVE_STATE]({ payload }) {
    const { id, isActive } = payload

    const result = yield call(services.setActiveState, id, isActive)
    yield put(actions.updated(id, result))

    message.success('设置完成')
    // setActiveState
  }
}
